'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/18.
                                          */

// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _components = require('components');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopSelling = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch(experienceShopActions.getSellings(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    sellingsData: state.experienceShop.sellingsData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopSelling, _Component);

  function ExperienceShopSelling() {
    (0, _classCallCheck3.default)(this, ExperienceShopSelling);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopSelling).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0,
      startDate: null,
      endDate: null
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopSelling, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var getSellings = this.props.getSellings;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      if (clickItem === '') {
        this.setState({
          filter: '',
          orderItem: '',
          direction: '',
          startDate: null,
          endDate: null
        });
        currentFilter = '';
        currentDirection = '';
      } else if (clickItem === 'money') {
        if (direction === 'ASC') {
          currentDirection = 'DESC';
        }
        this.setState({
          orderItem: 'money',
          direction: currentDirection
        });
      }
      if (getSellings) {
        getSellings(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var getSellings = this.props.getSellings;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (getSellings) {
        this.setState({
          currentPage: page
        });
        getSellings(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var getSellings = this.props.getSellings;
      var _state3 = this.state;
      var orderItem = _state3.orderItem;
      var direction = _state3.direction;
      var filter = _state3.filter;

      var value = this.refs.searchInput.value;
      if (getSellings) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        getSellings(currentFilter, 0, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onDateChange',
    value: function onDateChange(_ref2) {
      var startDate = _ref2.startDate;
      var endDate = _ref2.endDate;

      // console.log(startDate, endDate);
      this.setState({ startDate: startDate, endDate: endDate });
      var getSellings = this.props.getSellings;
      var _state4 = this.state;
      var orderItem = _state4.orderItem;
      var direction = _state4.direction;
      var filter = _state4.filter;

      if (!!getSellings) {
        var currentFilter = filter;
        if (startDate && endDate) {
          currentFilter = (0, _extends3.default)({}, filter, { RangeQuery: {
              keyWord: 'buyTime',
              start: startDate.format('YYYY/MM/DD'),
              end: endDate.format('YYYY/MM/DD')
            }
          });
        } else {
          delete currentFilter.RangeQuery;
        }
        this.setState({
          filter: currentFilter
        });
        if (!!startDate && !!endDate || !startDate && !endDate) {
          getSellings(currentFilter, 0, { orderItem: orderItem, direction: direction });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ExperienceShopSelling.scss');
      var sellingsData = this.props.sellingsData;
      var _state5 = this.state;
      var orderItem = _state5.orderItem;
      var currentPage = _state5.currentPage;
      var startDate = _state5.startDate;
      var endDate = _state5.endDate;

      var sellingsShow = '';
      var errorLabel = '';
      var totalPageNumber = 1;
      if (sellingsData) {
        var experienceSellingsData = sellingsData.experienceSellingsData;
        var experienceSellingsDataError = sellingsData.experienceSellingsDataError;
        var experienceSellingsDataRecordCount = sellingsData.experienceSellingsDataRecordCount;
        var experienceSellingsDataPagesize = sellingsData.experienceSellingsDataPagesize;

        if (experienceSellingsDataError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: experienceSellingsDataError });
        } else if (experienceSellingsData && experienceSellingsData instanceof Array) {
          sellingsShow = experienceSellingsData.map(function (sellings, index) {
            return _react2.default.createElement(
              'tr',
              { key: sellings.id + index, style: { background: index % 2 === 0 ? '#f9f8f8' : '' } },
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                currentPage * 20 + index + 1
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.buyTime
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.memberName
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.productName
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.shop
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.money
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.commissionPercent
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                sellings.commission
              )
            );
          });
          totalPageNumber = parseInt(experienceSellingsDataRecordCount / experienceSellingsDataPagesize, 10);
          if (experienceSellingsDataRecordCount % experienceSellingsDataPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      _moment2.default.locale('zh-cn');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === '' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('');
              } },
            '全部'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'money' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('money');
              } },
            '购买金额'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.larbox, style: { display: 'none' } },
          _react2.default.createElement(_components.GoeasyDateRangePicker, { withPortal: true,
            showClearDates: true,
            startDate: startDate,
            endDate: endDate,
            isOutsideRange: function isOutsideRange() {
              return false;
            },
            dateChange: this.onDateChange.bind(this),
            initialVisibleMonth: function initialVisibleMonth() {
              return startDate || (0, _moment2.default)();
            },
            showDefaultInputIcon: true,
            startDatePlaceholderText: '开始日期',
            endDatePlaceholderText: '结束日期',
            displayFormat: 'YYYY/MM/DD',
            monthFormat: 'YYYY[年]MMMM',
            phrases: { closeDatePicker: '关闭', clearDates: '清除日期' } })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jsallshou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { onClick: this.onSearch.bind(this) },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '', className: 'img' })
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '7%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '17%' }),
            _react2.default.createElement('col', { width: '23%' }),
            _react2.default.createElement('col', { width: '14%' }),
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '9%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '序号'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买时间'
              ),
              _react2.default.createElement(
                'th',
                null,
                '姓名'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买艺品'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买店铺'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买金额'
              ),
              _react2.default.createElement(
                'th',
                null,
                '提成比例'
              ),
              _react2.default.createElement(
                'th',
                null,
                '提成金额'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            sellingsShow
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        errorLabel,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopSelling;
}(_react.Component), _class2.propTypes = {
  sellingsData: _react.PropTypes.object,
  getSellings: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ExperienceShopSelling;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopSelling/ExperienceShopSelling.js
 ** module id = 1482
 ** module chunks = 0
 **/